import React, {useMemo} from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Popover, Row} from "antd";
import {EditOutlined, EllipsisOutlined, FileTextOutlined} from "@ant-design/icons";
import {formatDateShort, formatGrade} from "@lib/format";
import {DiamondIcon, FlameIcon, StorageBoxOutlineIcon} from "@components/icons/Icons";
import {FmvPrice} from "@components/fmv-price";
import {KeyIssueBadge} from "@components/key-issue-badge";

const WishlistListItemDesktop = ({
    item,
    showEditMultiple,
    isSelected,
    toggleSelected,
    bookCover,
    searchCollection,
    issueDate,
    showValueRibbon,
    setShowEdit,
    setAddIssueId,
    wishlistIssueRemove,
    windowDimensions,
}) => {

    const smallButtons = useMemo(() => {
        return windowDimensions.under(1200);
    }, [windowDimensions]);

    return (
        <Row className="grid-list-item">
            {showEditMultiple && (
                <Col span={1}  className="col-cbx">
                    <Checkbox
                        className="checkbox"
                        checked={isSelected}
                        onChange={() => toggleSelected(item.id)}
                    />
                </Col>
            )}
            <Col className={smallButtons ? "width-85px" : "width-135px"}>
                <div className="col-image">
                    {bookCover}
                </div>
            </Col>

            <Col className="col-desc flex-grow-1">
                <div className="valueBadges">
                    {item.is_key && (<KeyIssueBadge keyInfo={item.key_info} windowDimensions={windowDimensions} isLargeScreen={true} />)}
                    {item.is_hot && (<div className="valueBadge hotIssue isActive"><FlameIcon /></div>)}
                    {item.is_rare && (<div className="valueBadge rareIssue isActive"><DiamondIcon /></div>)}
                </div>

                <div className="col-issue-desc">
                    {item.total_in_collection > 0 && (
                        <div className="pad-bot-5" >
                            <a onClick={() => { if(searchCollection) searchCollection(item.series_title + ' '+item.issue_number) }}>
                                <span className="issues-owned">
                                    <StorageBoxOutlineIcon /><strong>&nbsp;:&nbsp;<span className="total-number">{item.total_in_collection}</span></strong>
                                </span>
                            </a>
                        </div>
                    )}
                    <a href={`/issue/${item.slug}`}>
                        <div className="cursor-pointer titleLink">{item.series_title}: {item.issue_number}</div>
                    </a>
                    <span className="font-12 font-normal">
                        {item.is_variant ? item.variant_name : 'Regular'}<br/>
                        {item.publisher} | {formatDateShort(issueDate)}
                    </span>
                </div>
            </Col>
            <Col span={2} className="flex-col">
                <div className="col-center">
                    {item.wishlist_qty ? item.wishlist_qty : 1}
                </div>
            </Col>
            <Col span={3} className="flex-col">
                <div className="col-center">
                    {item.graded_by ? item.graded_by.toUpperCase() : 'RAW'}{' | '+formatGrade(item.grade)}
                </div>
            </Col>
            <Col span={3} className={"flex-col "}>
                <div className="mar-auto-0 flex-align-center">
                    {showValueRibbon ? (
                        <FmvPrice
                            prefix={
                                (item.is_most_common_value && item.most_common_grade) ?
                                 ('('+formatGrade(item.most_common_grade)+') ') :
                                null
                            }
                            value={item.value}
                            stale={item.stale}
                        />
                    ) : (
                        <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                    )}
                </div>
            </Col>
            <Col span={2} className="flex-col">
                <div className="col-center">
                    {item.notes && (
                        <Popover content={item.notes}>
                            <Button className="greyButton" size={smallButtons ? "small" : "large"} >
                                <FileTextOutlined />
                            </Button>
                        </Popover>
                    )}
                </div>
            </Col>
            <Col span={2} className="flex-col">
                <div className="col-center">
                    <Button className="greyButton" size={smallButtons ? "small" : "large"} onClick={() => {
                        setShowEdit(true);
                    }} >
                        <EditOutlined className="font-12" />
                    </Button>

                    <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                        <Menu >
                            <Menu.Item key={0} onClick={() => setAddIssueId(item.id)}>Add To Collection</Menu.Item>
                            <Menu.Item key={1} onClick={() => wishlistIssueRemove([item.id])} >Remove from Wishlist</Menu.Item>
                            <Menu.Item key={2}><a href={`/issue/${item.slug}`}>Go to Price Guide</a></Menu.Item>
                            <Menu.Item key={3} ><a href={`/marketplace/?issue_id=${item.id}`}>Buy in Marketplace</a></Menu.Item>
                        </Menu>
                    )}>
                        <Button className="greyButton mar-left-5" size={smallButtons ? "small" : "large"} >
                            <EllipsisOutlined className="font-12" />
                        </Button>
                    </Dropdown>

                </div>
            </Col>
        </Row>
    );

};

export default WishlistListItemDesktop;